module.exports = __webpack_public_path__ + "media/images/cbs/map-home-c475ad1b021c4ff00206adbb0a5774fe.svg";